import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { useTranslation } from 'hooks/use-translation';
import { FinancialsPage } from './financials-page';

const PageContent = styled(Page.Content)`
  width: 80%;
  padding: var(--layout-03) calc(var(--layout-03) + var(--spacing-03));

  > .ant-row {
    padding: var(--spacing-03);
  }
`;

export const Financials: FC = () => {
  const title = useTranslation('settings.financials');

  return (
    <Page>
      <Page.Header
        $white
        title={<Page.Header.Title>{title}</Page.Header.Title>}
      />
      <PageContent>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <FinancialsPage />
      </PageContent>
    </Page>
  );
};
